import React from 'react'; 
import SocialMediaLinks from '../components/SocialMediaLinks';

const Footer = () => {
    return(
        <div className="footer-container">
            <SocialMediaLinks />
            <div className="footer-content">
                <p style={{ margin: 0 }}>&copy; {new Date().getFullYear()} Healing Waters For Warriors. All rights reserved.</p>
                {/* <p style={{ margin: 0 }}>Designed by Your Name or Company</p>
                <p style={{ margin: 0 }}>
                    <a href="/privacy-policy" style={{ textDecoration: 'none', color: '#007bff' }}>Privacy Policy</a> | 
                    <a href="/terms-of-service" style={{ textDecoration: 'none', color: '#007bff', marginLeft: '5px' }}>Terms of Service</a>
                </p> */}
            </div>
        </div>
    )
}

export default Footer; 